import { render } from "./componentEditHub.vue?vue&type=template&id=4d54d058"
import script from "./componentEditHub.vue?vue&type=script&lang=js"
export * from "./componentEditHub.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__